var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgContractFill = function SvgContractFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 19v-1q0-.824.587-1.413A1.93 1.93 0 0 1 5 16h1V4q0-.824.588-1.412A1.93 1.93 0 0 1 8 2h11q.824 0 1.413.587Q21 3.176 21 4v15q0 1.25-.875 2.125A2.9 2.9 0 0 1 18 22zm12-2q.424 0 .712-.288A.97.97 0 0 0 19 19V4H8v12h7q.824 0 1.413.587Q17 17.176 17 18v1q0 .424.288.712.287.288.712.288M10 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 8q0-.424.287-.713A.97.97 0 0 1 10 7h7q.424 0 .712.287Q18 7.576 18 8q0 .424-.288.713A.97.97 0 0 1 17 9zm0 3a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 11q0-.424.287-.713A.97.97 0 0 1 10 10h7q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContractFill);
export { ForwardRef as ReactComponent };